var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E7EFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_10061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2751 51.8493C29.6867 51.8835 29.108 51.6879 28.6611 51.3037C27.7796 50.417 27.7796 48.985 28.6611 48.0983L47.9613 28.798C48.8781 27.9402 50.3166 27.9878 51.1745 28.9046C51.9502 29.7336 51.9954 31.0078 51.2803 31.8897L31.8663 51.3037C31.4252 51.6823 30.8558 51.8776 30.2751 51.8493Z",
    fill: "#395B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5525 51.8493C48.9562 51.8468 48.3846 51.6101 47.9612 51.1901L28.6609 31.8897C27.8443 30.9361 27.9553 29.501 28.9089 28.6843C29.76 27.9555 31.0152 27.9555 31.8662 28.6843L51.2802 47.9847C52.1967 48.8427 52.2441 50.2813 51.3861 51.1979C51.3519 51.2343 51.3167 51.2696 51.2802 51.3037C50.8048 51.7171 50.1792 51.9147 49.5525 51.8493Z",
    fill: "#395B9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_10061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCancelIcon);
export default __webpack_public_path__ + "static/media/menuCancelIcon.339990a2778ce65eba01f5e9747756cc.svg";
export { ForwardRef as ReactComponent };